import { useEffect } from 'react';
import AppShell from '../components/AppShell';
import PrimaryButton from '../components/PrimaryButton';
import { APK_DOWNLOAD_URL, startApkDownload } from '../deepLink';

function DownloadPage() {
  useEffect(() => {
    const timerId = window.setTimeout(startApkDownload, 600);
    return () => window.clearTimeout(timerId);
  }, []);

  return (
    <AppShell>
      <section className="hero compact-hero">
        <div className="hero-badge">Загрузка APK</div>
        <h1>Скачивание CryptoFog скоро начнётся</h1>
        <p>
          Если браузер не начал скачивание автоматически, нажми кнопку ниже.
        </p>
        <div className="hero-actions">
          <PrimaryButton href={APK_DOWNLOAD_URL}>Скачать APK</PrimaryButton>
          <PrimaryButton variant="ghost" href="/">На главную</PrimaryButton>
        </div>
      </section>
    </AppShell>
  );
}

export default DownloadPage;
